module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subComponent"
  }, [_c('el-dialog', {
    attrs: {
      "title": "新增材料",
      "visible": _vm.openstate,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.openstate = $event
      },
      "open": _vm.openHandle,
      "closed": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "cbody"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("名称")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("来源")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "source"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.params.source),
      callback: function($$v) {
        _vm.$set(_vm.params, "source", $$v)
      },
      expression: "params.source"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("其他要求")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "size": "medium",
      "placeholder": "请输入其他要求"
    },
    model: {
      value: (_vm.params.otherRequirements),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherRequirements", $$v)
      },
      expression: "params.otherRequirements"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("原件份数")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "originalNumber"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.originalNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "originalNumber", $$v)
      },
      expression: "params.originalNumber"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("复印件份数")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "photocopyNumber"
    }
  }, [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params.photocopyNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "photocopyNumber", $$v)
      },
      expression: "params.photocopyNumber"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.openstate = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.goSubAdd
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-b3a4984a"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/affairs/src/newMet.vue
// module id = 1550
// module chunks = 1